var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 49.881,
    viewBox: "0 0 50 49.881",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #004057;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons-13",
    transform: "translate(-7.551 -4.637)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7633",
    "data-name": "Path 7633",
    className: "cls-1",
    d: "M8.372,21.2H18.743V54.518H8.372ZM13.563,4.637a6.007,6.007,0,1,1-6.012,6,6.005,6.005,0,0,1,6.012-6",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7634",
    "data-name": "Path 7634",
    className: "cls-1",
    d: "M18.169,14.9H28.1V19.46h.136a10.893,10.893,0,0,1,9.811-5.384c10.485,0,12.421,6.9,12.421,15.868V48.219H40.123v-16.2c0-3.867-.074-8.837-5.384-8.837s-6.216,4.212-6.216,8.554V48.219H18.169V14.9Z",
    transform: "translate(7.079 6.293)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.25cd11587436cbba12c4eb486e869db6.svg";
export { ForwardRef as ReactComponent };